export * from './table-file-link.interface';
export { TableFileLinkComponent } from './table-file-link.component';
export { TableFileLinkModule } from './table-file-link.module';
